import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";

//Import actions
import { getShipmentCarrier as onGetShipmentCarriers, addNewShipmentCarrier as onAddNewShipmentCarrier, updateShipmentCarrier as onUpdateShipmentCarrier, deleteShipmentCarrier as onDeleteShipmentCarrier, getShipmentCarrierLoading, resetShipmentCarrierState } from "../../../store/shipmentCarrier/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";

const ShipmentCarrier = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, companies, companyLoading, shipmentCarriers, isShipmentCarrierCreated, isShipmentCarrierSuccess, loading, error } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    shipmentCarriers: state.ShipmentCarrier.shipmentCarriers,
    isShipmentCarrierCreated: state.ShipmentCarrier.isShipmentCarrierCreated,
    isShipmentCarrierSuccess: state.ShipmentCarrier.isShipmentCarrierSuccess,
    loading: state.ShipmentCarrier.loading,
    error: state.ShipmentCarrier.error,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [shipmentCarrierList, setShipmentCarrierList] = useState([]);
  const [shipmentCarrier, setShipmentCarrier] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [printDoc, setPrintDoc] = useState([]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const typeData = [
    {
      options: [
        { label: "Sales", value: "Sales" },
        { label: "Purchase", value: "Purchase" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const onClickDelete = (shipmentCarrier) => {
    setShipmentCarrier(shipmentCarrier);
    setDeleteModal(true);
  };

  const handleDeleteShipmentCarrier = () => {
    if (shipmentCarrier) {
      dispatch(onDeleteShipmentCarrier(shipmentCarrier));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  // useEffect(() => {
  //   setShipmentCarrierList(shipmentCarriers);
  // }, [shipmentCarriers]);

  useEffect(() => {
    if (!isEmpty(shipmentCarriers)) {
      let filteredShipmentCarriers = shipmentCarriers;
      if (activeTypeTab !== "all") {
        filteredShipmentCarriers = shipmentCarriers.filter((shipmentCarrier) => shipmentCarrier.shipment_carrier_status.name === activeTypeTab);
      }
      setShipmentCarrierList(filteredShipmentCarriers.map((el) => ({ ...el, isChecked: false })));
    }
  }, [shipmentCarriers]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Type",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (shipmentCarrierList.length > 0) {
      shipmentCarrierList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              // if (doc.id === "cvl_account_branch") {
              //   doc.data.push(value?.name ?? "-");
              // } else if (doc.id === "cvl_account_category") {
              //   const type = dataDoc.find((d) => d.id === "type");
              //   type.data.push(value?.type ?? "-");
              //   doc.data.push(value?.name ?? "-");
              // } else {
              //   doc.data.push(value ?? "-");
              // }
              doc.data.push(value ?? "-");
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [shipmentCarrierList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredShipmentCarriers = shipmentCarriers;
      if (type !== "all") {
        filteredShipmentCarriers = shipmentCarriers.filter((shipmentCarrier) => shipmentCarrier.shipment_carrier_status.name === type);
      }
      setShipmentCarrierList(filteredShipmentCarriers);
    }
  };

  useEffect(() => {
    setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
    dispatch(resetShipmentCarrierState());
    dispatch(onGetShipmentCarriers());
  }, []);

  // useEffect(() => {
  //   setShipmentCarrier(shipmentCarriers);
  // }, [shipmentCarriers]);

  useEffect(() => {
    if (!isEmpty(shipmentCarriers)) {
      // setShipmentCarrier(shipmentCarriers);
      setIsEdit(false);
    }
  }, [shipmentCarriers]);

  // useEffect(() => {
  //   if (!isEmpty(shipmentCarriers)) {
  //     setShipmentCarrierList(shipmentCarriers);
  //   }
  // }, [shipmentCarriers]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setShipmentCarrier(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleShipmentCarrierClick = useCallback(
    (arg) => {
      const shipmentCarrier = arg;
      setShipmentCarrier({
        id: shipmentCarrier.id,
        name: shipmentCarrier.name,
        type: shipmentCarrier.type && { label: shipmentCarrier.type, value: shipmentCarrier.type },
        description: shipmentCarrier.description,
        company: shipmentCarrier.shipment_carrier_company && {
          label: shipmentCarrier.shipment_carrier_company.name,
          value: shipmentCarrier.shipment_carrier_company.id,
        },
        client: shipmentCarrier.asset_class_client && {
          label: shipmentCarrier.shipment_carrier_client.name,
          value: shipmentCarrier.shipment_carrier_client.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, userType]
  );

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (shipmentCarrier && shipmentCarrier.name) ?? "",
      type: (shipmentCarrier && shipmentCarrier.type) ?? "",
      description: (shipmentCarrier && shipmentCarrier.description) ?? "",
      client: (shipmentCarrier && shipmentCarrier.client) || clientSelected,
      company: (shipmentCarrier && shipmentCarrier.company) || companySelected,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter shipment name"),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      company: Yup.object().required("Please Select Company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getShipmentCarrierLoading());
      if (isEdit) {
        const updateShipmentCarrier = {
          id: shipmentCarrier ? shipmentCarrier.id : 0,
          name: values.name,
          type: values.type.value,
          description: values.description,
          companyId: values.company.value,
          clientId: values.client.value,
        };
        dispatch(onUpdateShipmentCarrier(updateShipmentCarrier));
        validation.resetForm();
      } else {
        const newShipmentCarrier = {
          name: values.name,
          type: values.type.value,
          description: values.description,
          companyId: values.company.value,
          clientId: values.client.value,
        };
        dispatch(onAddNewShipmentCarrier(newShipmentCarrier));
        validation.resetForm();
      }
      toggle();
    },
  });

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteShipmentCarrier(element.value));
    });
    checkall.checked = false;
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = shipmentCarrierList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setShipmentCarrierList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = shipmentCarrierList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setShipmentCarrierList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateShipmentCarrier") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleShipmentCarrierClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteShipmentCarrier") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Tipe",
        accessor: "type",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "shipment_carrier_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
    ],
    [shipmentCarrierList, handleShipmentCarrierClick, userRole, userType, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = shipmentCarrierList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setShipmentCarrierList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => shipmentCarrierList, [shipmentCarrierList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleShipmentCarrierStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      type: "Purchase",
    };
    dispatch(onGetShipmentCarriers(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setShipmentCarrierList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetShipmentCarrierState());
    dispatch(onGetShipmentCarriers());
  };

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  document.title = "Shipment Carriers | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={shipmentCarrierList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteShipmentCarrier} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Opsi Pembelian" pageTitle="Kurir Ekpedisi">
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createShipmentCarrier") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={printDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteShipmentCarrier") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="shipmentCarrierList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SEMUA KURIR
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={9}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={1}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Shipment Carrier" : "Add Shipment Carrier"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Select
                              name="type"
                              placeholder="Pilih Tipe"
                              value={validation.values.type}
                              onChange={(e) => {
                                validation.setFieldValue("type", e);
                              }}
                              options={typeData}
                            ></Select>
                            {validation.touched.type && validation.errors.type && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.type}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Shipment Name
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Add Shipment Carrier"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ShipmentCarrier;
